import React from "react";
import { observer } from "mobx-react";
import { UserWidgetConfigUpdateStore } from "../../store";
import { UserWidgetConfigUpdateForm } from "./UserWidgetConfigUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type UserWidgetConfigUpdateProps = {
  userWidgetConfigUpdateStore: UserWidgetConfigUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const UserWidgetConfigUpdate: React.FC<UserWidgetConfigUpdateProps> =
  observer(
    ({ userWidgetConfigUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={userWidgetConfigUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={userWidgetConfigUpdateStore.savedButOutdated}
            onReload={() =>
              userWidgetConfigUpdateStore.reloadUserWidgetConfig()
            }
            reloadDisabled={userWidgetConfigUpdateStore.isProcessing}
          />
          <UserWidgetConfigUpdateForm
            userWidgetConfigUpdateStore={userWidgetConfigUpdateStore}
            userError={userWidgetConfigUpdateStore.errors.user?.message}
            onUserChange={(value) => {
              userWidgetConfigUpdateStore.setUserValue(value);
            }}
            userSelectedValue={
              userWidgetConfigUpdateStore.entityValues.showUser
            }
            onUserSelected={(value) => {
              userWidgetConfigUpdateStore.setSelectedUser(value);
            }}
            userOptions={userWidgetConfigUpdateStore.getUserOptions()}
            widgetError={userWidgetConfigUpdateStore.errors.widget?.message}
            onWidgetChange={(value) => {
              userWidgetConfigUpdateStore.setWidgetValue(value);
            }}
            widgetSelectedValue={
              userWidgetConfigUpdateStore.entityValues.showWidget
            }
            onWidgetSelected={(value) => {
              userWidgetConfigUpdateStore.setSelectedWidget(value);
            }}
            widgetOptions={userWidgetConfigUpdateStore.getWidgetOptions()}
            enabledError={userWidgetConfigUpdateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              userWidgetConfigUpdateStore.setEnabledValue(value);
            }}
            enabled={userWidgetConfigUpdateStore.entityValues.enabled}
            positionError={userWidgetConfigUpdateStore.errors.position?.message}
            onPositionChange={(value: string) => {
              userWidgetConfigUpdateStore.setPositionValue(value);
            }}
            position={userWidgetConfigUpdateStore.entityValues.position}
            configOverrideError={
              userWidgetConfigUpdateStore.errors.configOverride?.message
            }
            onConfigOverrideChange={(value: string) => {
              userWidgetConfigUpdateStore.setConfigOverrideValue(value);
            }}
            configOverride={
              userWidgetConfigUpdateStore.entityValues.configOverride
            }
            displayOrderError={
              userWidgetConfigUpdateStore.errors.displayOrder?.message
            }
            onDisplayOrderChange={(value: number | undefined) => {
              userWidgetConfigUpdateStore.setDisplayOrderValue(value);
            }}
            displayOrder={userWidgetConfigUpdateStore.entityValues.displayOrder}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={userWidgetConfigUpdateStore.saveDisabled}
            onSave={() => userWidgetConfigUpdateStore.saveUserWidgetConfig()}
            onCancel={() =>
              userWidgetConfigUpdateStore.cancelUserWidgetConfig()
            }
          />
          <ErrorDialog
            open={userWidgetConfigUpdateStore.errorDialogOpened}
            title={userWidgetConfigUpdateStore.errorTitle}
            description={userWidgetConfigUpdateStore.errorDescription}
            onClose={() => userWidgetConfigUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={userWidgetConfigUpdateStore.confirmDialogOpened}
            title={userWidgetConfigUpdateStore.confirmDialogTitle}
            description={userWidgetConfigUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              userWidgetConfigUpdateStore.executeConfirmedAction()
            }
            onCancel={() => userWidgetConfigUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
